/**
 * Crossed-hash icon used by the price-level legend to mean "no trips found".
 * Uses currentColor so it inherits the legend label color, and sizes via 1em
 * so it scales with the surrounding font.
 */
const NoTripsIcon = ({ className = '' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    width="1em"
    height="1em"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    aria-hidden="true"
    className={className}
  >
    <path d="M5 2 L3.5 14 M11 2 L9.5 14 M2 6 H13 M2 10 H12" />
    <path d="M14 2 L2 14" />
  </svg>
);

export default NoTripsIcon;
